import React, { useState } from "react";
import SingleSelect from "widgets/Dropdown/SingleSelect";
import { DOWNLOAD_SCRIPT_TYPE, DAY_SHEET_REPORTS } from "constants/constants";
import { Heading1 } from "widgets";
import styles from "./Download.module.scss";
import DaySheetDownload from "components/DaySheetDownload/DaySheetDownload";

const Download = () => {
  const [selectedScriptName, setSelectedScriptName] = useState("");

  return (
    <div className={styles.downloadContainer}>
      <div className={styles.scriptSelectorContainer}>
        <div className={styles.scriptSelectorRow}>
          <Heading1 heading="Choose an action" />

          <div className={styles.scriptSelector}>
            <SingleSelect
              menuItems={DOWNLOAD_SCRIPT_TYPE}
              value={selectedScriptName}
              handleChange={(e) => setSelectedScriptName(e.target.value)}
            />
          </div>
        </div>

        {selectedScriptName === DAY_SHEET_REPORTS && <DaySheetDownload />}
      </div>
    </div>
  );
};

export default Download;
